import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { LayoutProps } from './Layout.types'
import { ProgressBar } from '@app/code/src/components/molecules/progress-bar'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { useLayoutState } from './Layout.hooks'
import React from 'react'

export const Layout: React.FC<LayoutProps> = ({
  children,
  currStep = 0,
  totalSteps = 0,
  showBackButton = true,
  showProgressBar = true,
  handleBack,
  containerBoxProps,
  childrenBoxProps,
  navigationBoxProps,
  progressBarHeight = '10px',
  showDesktopProgressBar,
  showDesktopBackButton,
  isDesktopLayout = false
}) => {
  const { showBackButtonOrProgressBar, percentage } = useLayoutState({
    currStep,
    totalSteps,
    showBackButton,
    showProgressBar
  })
  return (
    <Box flexDirection="column" width="100%" {...containerBoxProps}>
      {showBackButtonOrProgressBar && (
        <Box alignItems="center" justifyContent="space-between" {...navigationBoxProps}>
          {showBackButton && (
            <Icon
              style={showDesktopBackButton ? { cursor: 'pointer' } : undefined}
              alt="back"
              src={'/icons/ArrowLeftLarge.svg'}
              display={['flex', 'flex', showDesktopBackButton ? 'flex' : 'none']}
              onClick={() => handleBack?.()}
              width="24px"
              height="20px"
            />
          )}
          {showProgressBar && (
            <Box
              display={['flex', 'flex', showDesktopProgressBar ? 'flex' : 'none']}
              justifyContent={isDesktopLayout ? 'center' : undefined}
              width="100%"
            >
              <Spacer mr="24px" />
              <ProgressBar
                height={progressBarHeight}
                percentage={`${percentage}%`}
                backgroundColor="secondary.border"
                borderRadius="100px"
                maxWidth={isDesktopLayout ? '600px' : undefined}
                barProps={{
                  backgroundColor: 'primary.black',
                  borderRadius: '12px'
                }}
              />
            </Box>
          )}
        </Box>
      )}
      <Box
        width={isDesktopLayout ? '100%' : ['100%', '400px', '400px']}
        flexDirection="column"
        margin="0 auto"
        height="100%"
        {...childrenBoxProps}
      >
        {children}
      </Box>
      <Spacer mb="32px" />
    </Box>
  )
}
